<ion-app>
  <ng-container *ngIf="showMaintenance; else mainApp">
  <ion-content class="maintenance-overlay " fullscreen>
    <div class="maintenance-container">
      <div class="maintenance-box">
        <ion-icon name="construct-outline" class="maintenance-icon"></ion-icon>
        <h1 class="maintenance-title">Under Maintenance</h1>
        <p class="maintenance-message">{{ message }}</p>
        <p class="maintenance-subtext">Thanks for your patience!</p>
      </div>
    </div>
  </ion-content>
</ng-container>
  <ng-template #mainApp>
    <ion-router-outlet></ion-router-outlet>
  </ng-template>
</ion-app>
<viso-online-status></viso-online-status>
